export function createAlgoliaFacetFiltersFromQueryMetaData(algoliaQueryMetaData) {
  const {
    filters
  } = algoliaQueryMetaData;
  return filters.flatMap(filter => filter.value.map(item => "".concat(filter.key, ":").concat(item)));
}